
<script>
  import ToolBar from './components/ToolBar.vue'
  import Footer from './components/Footer.vue'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      ToolBar,
      Footer
    },
    computed:{
      ...mapGetters([
        'profile',
        'authenticated'
      ])
    }
  }
</script>
<template>
  
  <div class="bg">
    <!-- <div class="bg-blur"></div> -->
    <ToolBar v-if="profile" :profile="profile" />
    <router-view />
    <Footer />
  </div>
  
</template>